import { useEffect, useState } from "react";
import { RoutedModal } from "../../../common";

const EndOfDayMetabase = ({
  advancedEndOfDay,
  setProps = () => {},
  setAdvancedEndOfDay = () => {},
}) => {
  const [isExportVideo, setIsExportVideo] = useState(false);

  useEffect(() => {
    setProps({
      headerTitle: "Advanced End of Day",
      headerDescription:
        "You can customize how you want to receive your end of day with the options below",
      hasPrevNavigation: true,
      routeToPrev: () => setAdvancedEndOfDay(null),
    });
  }, []);

  return (
    <>
      <span
        className="ml-auto cursor-pointer purple--text"
        style={{ textDecoration: "underline" }}
        onClick={() => setIsExportVideo(true)}
      >
        View How To Export
      </span>
      <iframe
        src={advancedEndOfDay?.iframe_url}
        title={"End of Day Metabase"}
        allowFullScreen
        width={"100%"}
        height={"1000px"}
        style={{ border: "none" }}
      />

      <RoutedModal
        width={850}
        isActive={isExportVideo}
        headerTitle="How To Export Advanced End of Day"
        closeModal={() => setIsExportVideo(false)}
        style={{ height: "500px" }}
      >
        <div style={{ height: "390px" }}>
          <iframe
            width="100%"
            height="100%"
            loading="lazy"
            src={"https://www.youtube.com/embed/3f0BWXUvZaA"}
            title={"How To Export Advanced End of Day"}
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
            allowfullScreen
            style={{ border: "none" }}
          ></iframe>
        </div>
      </RoutedModal>
    </>
  );
};
export default EndOfDayMetabase;
